/** Display label for SSID profile pickers: SSID name + VLAN profile name. */
export function formatSsidProfileOptionLabel(profile, vlans = []) {
  const ssidName = (profile?.ssid || profile?.name || profile?.id || '').trim();
  if (!ssidName) return '';

  const vlanId = String(profile?.vlan_profile_id || '').trim();
  if (!vlanId) return ssidName;

  const vlan = (vlans || []).find((v) => v.id === vlanId);
  if (!vlan) return `${ssidName} — VLAN`;

  const vlanName = (vlan.name || '').trim()
    || (vlan.number != null ? `VLAN ${vlan.number}` : 'VLAN');
  return `${ssidName} — ${vlanName}`;
}
